<template>
    <div class="comments comments-wrapper  mb-2">
        <slot/>
        <div class="comment panel-card">
            <div class="row no-gutters">
                <div class="comment-avatar col-md-1 col-2 text-center py-1">
                    <span><img class="mx-auto rounded-circle img-fluid" :src="item.img ?  appUrl.media+'/'+item.img :  imageUser" alt="avatar"></span>
                </div>
                <div class="comment-content col-md-11 col-sm-10 rtl text-right">
                    <div class="d-flex">
                        <h6 class="d-inline-block col-4 small comment-meta mb-0 pt-1">
                            <!-- Today, 2:38 -->
                            <span class="text-info mb-0">{{item.fullname}}</span>
                            _
                            <span class="text-dark mb-0">{{item.date | date}}</span>
                        </h6>
                        <div class="d-inline-block col-8 start-box rtl text-left">
                            <star-rating class="d-inline-block" :rtl="true" :read-only="true" :star-size="20" :show-rating="false" :increment="0.01" v-model="item.rate" :active-color="'#f4c150'" :rounded-corners="false" :inactive-color="'#ccc'" />
                        </div>
                        <!-- <div class="d-inline-block col-2 start-box rtl text-left">
                            <span class="text-info mb-0 pointer" @click="replyNew">پاسخ به این نظر</span>
                        </div> -->
                    </div>
                    <div class="col-12 col-md-12 mt-3 comment-body rtl text-rtl">
                        <p>
                            {{item.content}}
                        </p>
                    </div>
                    <!-- <div class="col-12 col-md-12 mt-3 comment-body rtl text-rtl">
                        <p class="text-left">
                            <span class="text-info mb-0 pointer" @click="$emit('getReply')">پاسخ ها</span>
                        </p>
                    </div> -->
                    <div class="col-12 col-md-2 mr-auto" v-if="isAdmin">
                        <div class="d-flex">
                            <button @click="$emit('editComment')" class="mt-1 mb-1 bttn-material-circle  bttn-md bttn-success flaticon-content mr-auto"  v-ripple :title="'ویرایش نظر'"></button>
                            <button @click="$emit('removeComment')" class="mt-1 mb-1 bttn-material-circle  bttn-material-circle  bttn-md bttn-danger flaticon-dustbin mr-auto"  v-ripple :title="'حذف نظر'"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'component-comments',
  props: ['item', 'isAdmin'],
  data () {
    return {
      starVal: 4.3
    }
  },
  methods: {
    replyNew (item, index) {
      this.$emit('replyComment')
    }
  }
}
</script>
<style lang="less">
.comments-wrapper{
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/comments.vue